import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dragLabel: {
		id: 'dashboard-edit.gadget-editable.title-editor.drag-label',
		defaultMessage: 'Drag to move gadget',
		description:
			'Label for an icon that indicates to the user that a gadget can be dragged to a new position',
	},
});
